import { Empty, Skeleton } from "antd";

const QuarterlyLeavesReport = ({
  checked,
  checked2,
  selectedReportType,
  leavesReport,
  filter,
  filteredData,
  year,
  loading,
}) => {
  // console.log("checked2", checked2);
  return (
    <>
      {loading ? (
        <>
          <Skeleton active={loading} />
        </>
      ) : leavesReport.length === 0 ? (
        <>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </>
      ) : (
        <>
          <div className="table-responsive">
            <table className="leave-report merged-table" id="myTable">
              <thead>
                <tr>
                  <th className="sticky-col sticky-header" colSpan={6}>
                    Employee Info
                  </th>

                  {checked && checked.includes("Q1") ? (
                    <>
                      <th colSpan={checked2.length + 2}>Jan to Mar {year}</th>
                    </>
                  ) : null}

                  {checked && checked.includes("Q2") ? (
                    <>
                      <th colSpan={checked2.length + 2}>Apr to June {year}</th>
                    </>
                  ) : null}

                  {checked && checked.includes("Q3") ? (
                    <>
                      <th colSpan={checked2.length + 2}>July to Sep {year}</th>
                    </>
                  ) : null}

                  {checked && checked.includes("Q4") ? (
                    <>
                      <th colSpan={checked2.length + 2}>Oct to Dec {year}</th>
                    </>
                  ) : null}
                </tr>
                <tr>
                  <th className="sticky-col sticky-header">Emp ID</th>
                  <th className="sticky-col sticky-header">Employee Name</th>
                  <th className="sticky-col sticky-header">Joining Date</th>
                  <th className="sticky-col sticky-header">
                    Confirmation Date
                  </th>
                  <th className="sticky-col sticky-header">Location</th>
                  <th className="sticky-col sticky-header">Leaves 2025</th>

                  {/* Dynamic leave columns */}
                  {selectedReportType.value === "1"
                    ? Array(checked.length)
                        .fill([
                          "Opening",
                          ...checked2.filter(Boolean),
                          "Closing",
                        ])
                        .flat()
                        .map((col, i) => <th key={i}>{col}</th>)
                    : Array(7)
                        .fill([
                          "Opening",
                          "Paid",
                          "C Off",
                          "Unpaid",
                          "LOP/Late Mark",
                          "Total Absent Days",
                          "Closing",
                        ])
                        .flat()
                        .map((col, i) => <th key={i}>{col}</th>)}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(leavesReport)
                  ? (filter ? filteredData : leavesReport).map((item, idx) => (
                      <tr key={idx}>
                        <td className="sticky-col">{item.employeeId}</td>
                        <td className="sticky-col">{item.empName}</td>
                        <td className="sticky-col">{item.joiningDate}</td>
                        <td className="sticky-col">{item.confirmationDate}</td>
                        <td className="sticky-col">{item.location}</td>
                        <td className="sticky-col">{item.allocatedLeaves}</td>

                        {checked && checked.includes("Q1") ? (
                          <>
                            {/* Q1 */}
                            <td>{item.queter1}</td>
                            {checked2 && checked2.includes("Paid") ? (
                              <>
                                {" "}
                                <td>{item.q1PaidLeaves}</td>
                              </>
                            ) : null}

                            {checked2 && checked2.includes("Goodwill") ? (
                              <>
                                {" "}
                                <td>{item.q1Goodwill}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("Unpaid") ? (
                              <>
                                {" "}
                                <td>{item.q1UnPaidLeaves}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("LOP/Late Mark") ? (
                              <>
                                <td></td>
                              </>
                            ) : null}
                            {checked2 &&
                            checked2.includes("Total Absent Days") ? (
                              <>
                                <td>
                                  {parseFloat(item.q1PaidLeaves) +
                                    parseFloat(item.q1UnPaidLeaves)}
                                </td>
                              </>
                            ) : null}

                            <td>
                              {parseFloat(item.queter1) -
                                parseFloat(item.q1PaidLeaves)}
                            </td>
                          </>
                        ) : null}
                        {checked && checked.includes("Q2") ? (
                          <>
                            {/* Q2 */}
                            <td>{item.q2Balance}</td>

                            {checked2 && checked2.includes("Paid") ? (
                              <>
                                {" "}
                                <td>{item.q2PaidLeaves}</td>
                              </>
                            ) : null}

                            {checked2 && checked2.includes("Goodwill") ? (
                              <>
                                {" "}
                                <td>{item.q2Goodwill}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("Unpaid") ? (
                              <>
                                {" "}
                                <td>{item.q2UnPaidLeaves}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("LOP/Late Mark") ? (
                              <>
                                <td></td>
                              </>
                            ) : null}
                            {checked2 &&
                            checked2.includes("Total Absent Days") ? (
                              <>
                                <td>
                                  {parseFloat(item.q2PaidLeaves) +
                                    parseFloat(item.q2UnPaidLeaves)}
                                </td>
                              </>
                            ) : null}

                            <td>
                              {parseFloat(item.q2Balance) -
                                parseFloat(item.q2PaidLeaves)}
                            </td>
                          </>
                        ) : null}

                        {checked && checked.includes("Q3") ? (
                          <>
                            {/* Q3 */}
                            <td>{item.q3balance}</td>

                            {checked2 && checked2.includes("Paid") ? (
                              <>
                                {" "}
                                <td>{item.q3PaidLeaves}</td>
                              </>
                            ) : null}

                            {checked2 && checked2.includes("Goodwill") ? (
                              <>
                                {" "}
                                <td>{item.q3Goodwill}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("Unpaid") ? (
                              <>
                                {" "}
                                <td>{item.q3UnPaidLeaves}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("LOP/Late Mark") ? (
                              <>
                                <td></td>
                              </>
                            ) : null}
                            {checked2 &&
                            checked2.includes("Total Absent Days") ? (
                              <>
                                <td>
                                  {parseFloat(item.q3PaidLeaves) +
                                    parseFloat(item.q3UnPaidLeaves)}
                                </td>
                              </>
                            ) : null}

                            <td>
                              {parseFloat(item.q3balance) -
                                parseFloat(item.q3PaidLeaves)}
                            </td>
                          </>
                        ) : null}

                        {checked && checked.includes("Q4") ? (
                          <>
                            {/* Q4 */}
                            <td>{item.q4Balance}</td>

                            {checked2 && checked2.includes("Paid") ? (
                              <>
                                {" "}
                                <td>{item.q4PaidLeaves}</td>
                              </>
                            ) : null}

                            {checked2 && checked2.includes("Goodwill") ? (
                              <>
                                {" "}
                                <td>{item.q4Goodwill}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("Unpaid") ? (
                              <>
                                {" "}
                                <td>{item.q4UnPaidLeaves}</td>
                              </>
                            ) : null}
                            {checked2 && checked2.includes("LOP/Late Mark") ? (
                              <>
                                <td></td>
                              </>
                            ) : null}
                            {checked2 &&
                            checked2.includes("Total Absent Days") ? (
                              <>
                                <td>
                                  {parseFloat(item.q4PaidLeaves) +
                                    parseFloat(item.q4UnPaidLeaves)}
                                </td>
                              </>
                            ) : null}

                            <td>
                              {parseFloat(item.q4Balance) -
                                parseFloat(item.q4PaidLeaves)}
                            </td>
                          </>
                        ) : null}
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default QuarterlyLeavesReport;
